import { render, staticRenderFns } from "./editMechanism.vue?vue&type=template&id=fb0b3e92&scoped=true&"
import script from "./editMechanism.vue?vue&type=script&lang=js&"
export * from "./editMechanism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0b3e92",
  null
  
)

export default component.exports